import TomSelect from 'tom-select'
import {Controller} from "@hotwired/stimulus"

let custom_items_plugin = function (tomSelect) {

    let self = this;

    let limit = 1;
    /**
     * addEvent copied from tom-select plugins
     */
    const addEvent = (target, type, callback, options) => {
        target.addEventListener(type, callback, options);
    };

    const createCounterEl = (count) => {
        const counter = document.createElement('div');
        counter.className = 'counter';
        counter.textContent = count + ' items selected';

        return counter;
    }

    function update_more_element() {
        let existingCounterEl = self.control.querySelectorAll('.counter')[0];
        if (self.items.length > limit) {
            self.control.querySelectorAll('.item').forEach(el => el.classList.add('d-none'));
            const newCounterEl = createCounterEl(self.items.length);
            if (existingCounterEl) {
                existingCounterEl.remove()
                self.control.append(newCounterEl);
            } else {
                self.control.append(newCounterEl);
            }
        } else {
            if (existingCounterEl) self.control.removeChild(existingCounterEl);
            self.control.querySelectorAll('.item').forEach(el => el.classList.remove('d-none'));
        }
    }

    self.on('initialize', update_more_element);
    self.on('item_add', update_more_element);
    self.on('item_remove', update_more_element);
    self.on('clear', update_more_element);
}

if (!TomSelect.plugins.hasOwnProperty('custom_items')) {
    TomSelect.define('custom_items', custom_items_plugin);
}

if (!TomSelect.plugins.hasOwnProperty('no_close')) {
    TomSelect.define('no_close', function () {
        this.close = function () {
        };
    });
}

export default class extends Controller {
    static values = {
        url: String,
        plugins: {type: Array, default: ['checkbox_options', 'caret_position', 'remove_button']},
        wrapperCss: {type: Array, default: []},
        controlCss: {type: Array, default: []},
        pluginsExclude: {type: Array, default: []},
        customOptions: {type: Array, default: []},
        create: false
    }

    disconnect() {
        if (this.element.tomselect) {
            this.element.tomselect.destroy();
        }
    }

    connect() {
        var url = this.urlValue
        var excludedPlugins = this.pluginsExcludeValue
        let plugins = excludedPlugins.length > 0 ? this.pluginsValue.filter(plugin => !excludedPlugins.includes(plugin)) : this.pluginsValue;
        var wrapperCss = this.wrapperCssValue
        var controlCss = this.controlCssValue
        const element = this.element

        if (url !== undefined && url !== '') {
            this.element.tomselect = new TomSelect(this.element, {
                valueField: 'id',
                labelField: 'text',
                delimiter: '|',
                searchField: 'text',
                plugins: plugins,
                openOnFocus: true,
                preload: 'focus',
                create: this.createValue,
                onChange: function () {
                    element.dispatchEvent(new Event('change', { bubbles: true }))
                    var form_id = this.input.dataset['changeFormId']
                    var argName = this.input.dataset['argumentName']
                    var argIndex = this.input.dataset['argumentIndex']
                    if (form_id !== undefined) {
                        var selectElements = document.querySelector(`[data-form-id="${form_id}"]`).querySelectorAll('[data-controller="select"]');
                        selectElements.forEach((ele) => {
                            if (ele.dataset['selectUrlValue'] !== undefined && ele.dataset['id'] !== this.input.dataset['id'] && parseFloat(ele.dataset['argumentIndex']) > parseFloat(argIndex)) {
                                var baseUrl = new URL(ele.dataset['selectUrlValue'], window.location.origin)
                                var searchParams = baseUrl.searchParams
                                var currentValue = this.getValue()
                                searchParams.delete(`${argName}[]`)
                                searchParams.delete(argName)
                                if (Array.isArray(currentValue)) {
                                    currentValue.forEach(val => {
                                        searchParams.append(`${argName}[]`, val);
                                    });
                                } else {
                                    searchParams.append(argName, currentValue)
                                }
                                baseUrl.search = searchParams.toString()
                                ele.dataset['selectUrlValue'] = baseUrl.toString()
                                ele.tomselect.clearOptions()
                                ele.tomselect.wrapper.classList.remove('preloaded')
                            }
                        })
                    }
                },
                onInitialize: function () {
                    if (plugins.includes('no_close')) {
                        this.open();
                    }
                    if (this.control) {
                        this.control.parentNode.classList.add(...wrapperCss)
                        this.control.classList.add(...controlCss)
                    }

                },
                // minimum query length
                shouldLoad: function (query) {
                    return query.length > 0;
                },
                // custom scoring
                // fetch remote data
                load: function (query, callback) {
                    var url1 = this.input.dataset['selectUrlValue']
                    var url2 = ''
                    if (url1.includes('?')) {
                        url2 = url1 + `&q=` + encodeURIComponent(query);
                    } else {
                        url2 = url1 + `?q=` + encodeURIComponent(query);
                    }
                    fetch(url2)
                        .then(response => response.json())
                        .then(json => {
                            callback(json.items);
                        }).catch(() => {
                        callback();
                    });
                },
            });
        } else {
            const config = {
                create: this.createValue,
                delimiter: '|',
                plugins: plugins,
                openOnFocus: false,
                onChange: function () {
                    element.dispatchEvent(new Event('change', { bubbles: true }))
                },
                onInitialize: function () {
                    if (plugins.includes('no_close')) {
                        this.open();
                    }
                    if (this.control) {
                        this.control.parentNode.classList.add(...wrapperCss);
                        this.control.classList.add(...controlCss);
                    }
                    this.control.addEventListener('click', () => {
                        this.open();
                    });
                }
            };
            if (this.customOptionsValue.length > 0) {
                const customOptions = this.customOptionsValue
                config.render = {
                    option: function (data, escape) {
                        let foundOption = customOptions.find(option => option.value === data.value);
                        return `<div class="flex items-center space-x-2">
                        <div class="${escape(foundOption.symbol)} h-[12px] w-[12px]"></div>
                        <span>${escape(foundOption.name)}</span>
                    </div>`;
                    },
                    item: function (data, escape) {
                        let foundOption = customOptions.find(option => option.value === data.value);
                        return `<div class="flex items-center space-x-2">
                        <div class="${escape(foundOption.symbol)} h-[12px] w-[12px]"></div>
                        <span>${escape(foundOption.name)}</span>
                    </div>`;
                    }
                };
            }

            this.element.tomselect = new TomSelect(this.element, config)
        }
    }
}
